import colors from "../../theme/Colours";

export const customerContainer = {
  padding: "40px 81px 18px",
  borderRadius: "15px",
};

const textFieldStyles = {
  "& .MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: colors.borderGrey,
    },
    "&.Mui-focused fieldset": {
      border: `1px solid ${colors.borderGrey}`,
    },
    "& input": {
      color: colors.quickBar,
    },
  },
  "& .MuiFormHelperText-root": {
    marginLeft: 0,
  },
};

const styledLabel = {
  color: colors.defaultFontColor,
  fontSize: "14px",
  fontWeight: "bold",
  paddingBottom: "7px",
  paddingTop: "32px",
};

export const titleContainer = {
  mb: 2,
  position: "relative",
  display: "flex",
  alignItems: "center",
};
export const customerPageTitle = {
  fontSize: "2rem",
  fontWeight: 500,
};

const greyTextStyles = {
  fontSize: "14px",
  color: colors.greytext,
};

const displayFlexJustifyEnd = {
  display: "flex",
  justifyContent: "flex-end",
  position: "relative",
  top: "21px",
  cursor: "pointer",
  marginBottom: "36px",
};

const editIconStyles = {
  width: "18px",
  height: "18px",
};

const uploadFileLabelStyles = {
  color: colors.defaultFontColor,
  fontSize: "14px",
  fontWeight: "bold",
  paddingBottom: "7px",
  paddingTop: "32px",
};

const uploadFileInputStyles = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: colors.fieldGreyBG,
      border: 0,
    },
    "&.Mui-focused fieldset": {
      border: 0,
    },
  },
  "& .MuiInputBase-input": {
    paddingLeft: 0,
    paddingBottom: "2px",
    paddingTop: "12px",
    fontSize: "14px",
  },
};

const uploadedFleNameContainerStyles = {
  border: `1px solid ${colors.fieldGreyBG}`,
  backgroundColor: colors.fileUploadBG,
  width: "fit-content",
  marginTop: "12px",
  padding: "5px",
  borderRadius: "2px",
};

const uploadedFleNameStyles = {
  color: colors.buttonBGColor,
  padding: "5px",
  fontSize: "14px",
};

const downloadAndCloseImgStyles = {
  height: "20px",
  width: "20px",
};

export {
  textFieldStyles,
  styledLabel,
  greyTextStyles,
  displayFlexJustifyEnd,
  editIconStyles,
  uploadFileLabelStyles,
  uploadFileInputStyles,
  uploadedFleNameContainerStyles,
  uploadedFleNameStyles,
  commonButtonStyles,
  downloadAndCloseImgStyles,
  commonPrimaryButtonStyles,
};

const commonButtonStyles = {
  width: "248px",
  height: "3rem",
  borderRadius: "4px",
  borderColor: colors.primaryButtonOrange,
  color: colors.primaryButtonOrange,
};
const commonPrimaryButtonStyles = {
  width: "248px",
  boxShadow: "none",
  background: colors.primaryButtonOrange,
  borderRadius: "4px",
};

export const generateAgreementButton = {
  ...commonPrimaryButtonStyles,
  width: "auto",
  padding: "0 24px",
  borderColor: colors.primaryButtonOrange,
  color: colors.background2,
};

export const downloadAgreementButton = {
  ...commonButtonStyles,
  width: "auto",
  padding: "0 24px",
  borderColor: colors.primaryButtonOrange,
  color: colors.primaryButtonOrange,
  "&:disabled": {
    borderColor: colors.primaryButtonOrangeDisabled,
    color: colors.primaryButtonOrangeDisabled,
  },
};

export const disabledButtonStyle = {
  backgroundColor: colors.fileUploadBG,
  color: colors.buttonBGColor,
  border: `1px solid ${colors.fieldGreyBG}`,
  opacity: 1, // Disable opacity dimming
  cursor: "not-allowed",
  "& .MuiButton-startIcon": {
    color: colors.buttonBGColor,
  },
};

// Dropdown styles for CustomDropdown component
export const dropdownStyles = (isDisabled: boolean) => ({
  button: {
    height: "48px",
    backgroundColor: "#EFEFEF",
    color: "#000000",
    fontSize: "16px",
    fontWeight: 400,
    fontFamily: "Roboto",
    textTransform: "none" as const,
    border: `1px solid ${isDisabled ? "#767676" : "#C4C4C4"}`,
  },
  label: {
    fontSize: "16px",
    color: "#000000",
    fontWeight: 400,
  },
});
